import { IoIosArrowDown } from 'react-icons/io';
import './index.css';
import SelectStatus from '../Select/SelectStatus';

export default function StatusButton({showSelectStatus, setShowSelectStatus, listStatus, setListStatus, selectedStatus, setSelectedStatus, setStatusButtonWasClicked}){
    return (
        <div className="status-div">
            <button className="status-button" onClick={() => setShowSelectStatus(!showSelectStatus)}>
                <div className="status-button__input">
                    <span>Status</span>
                    <IoIosArrowDown className="status-button___icon" />
                </div>
            </button>
            <SelectStatus 
                listStatus={listStatus}
                setListStatus={setListStatus}
                setShowSelectStatus={setShowSelectStatus}
                showSelectStatus={showSelectStatus}
                selectedStatus={selectedStatus}
                setSelectedStatus={setSelectedStatus}
                setStatusButtonWasClicked={setStatusButtonWasClicked} 
             />
        </div>
    )
}